import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/core/data.service';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { Header } from 'src/app/shared/components/header/header.model';
import * as moment from 'moment';
import { UploadService } from 'src/app/shared/services/upload.service';
import { BroadcastProxyFormFilter, ProxyFormGridColumn } from './adjudicationbroadcastproxyform.model';
import { AdjudicationProxyFormPopupComponent } from '../adjudication-proxyform-popup/adjudication-proxyform-popup.component';
import { MatSort } from '@angular/material/sort';
import { UserRole } from '../../creditor-home/user-profile/user-profile.model';
import { AuthorizationService } from 'src/app/shared/services/authorization.service';

@Component({
  selector: 'app-adjudication-proxyForm-screen',
  templateUrl: './adjudication-proxyForm-screen.component.html',
  styleUrls: ['./adjudication-proxyForm-screen.component.scss']
})
export class AdjudicationProxyFormScreenComponent {
    labelCaption: any;

    displayColumns: string[] = [
     // 'creditorName',
      'broadCastName',
      'documentType',
      'fileName',
      'submittedDateAndTime',
      'submittedBy'
    ];
    dataSource: any = [];
    footerdescription: string;
    predata: number[] = [];
    clonedArray: any = [];
    columnsToDisplay: string[] = [];
    totalPage: number=0;
    itemNumber: number = 1;
    startItemNumber: number;
    userId: string;
    engagementId: string;
    podId: string;
    creditorId: string;
    activeTab: string;
    result: string;
    key: any;
    newUploadedFiles: any[] = [];
    clonedDataSource: any;
    claimStatus: string;
    headerData: Header = new Header(); 
    headerData1: Header = new Header(); 
    engagementName:string;
    public broadcastGridList: any[];
    public broadcastDataFilterList: {};                                                                                                                                                            
    public totalCountLength: number = 0;
    public  pageNumber: number = 1;
    public  pageSize: number = 10;
    public selectedDataFilter: string;
    public filterParamString: string = '';
    public sortColumn: string = '';
    public broadcastAdjudicationFilter = new BroadcastProxyFormFilter();

    showRibbon: boolean = false;
    broadcastDetails :any[]=[];
    broadcastDocumentTypeLookup :any[];
    userRole: UserRole = new UserRole();
    accountmanagerOrDelegates: boolean;
    creditorName:string;
    isFromBroadcast:boolean=true;
    isProxyFrom:boolean=true;

      @ViewChild(MatSort) sort: MatSort;
    
    constructor(private utilitiesService: UtilitiesService, private activatedRoute: ActivatedRoute,
    private router: Router,private dialog: MatDialog,private spinnerService: NgxSpinnerService,private dataService: DataService,private uploadService: UploadService,private authorizationService:AuthorizationService) {
      this.headerData1.isHeaderRight = true;
      this.headerData1.isSubHeader=true;
      
    }
    
    ngOnInit(): void {
      //Get label caption
      let data = this.utilitiesService.GetLabelCaption(
        this.activatedRoute.snapshot.data.labelCaptionData,
        'Module_AboutUs'
      );
      if (data && data['Label']) {
        this.labelCaption = data['Label'];
      }
       this.activatedRoute.queryParams.subscribe(params=>{
        this.engagementId=params['engagementId'];
        this.headerData.headTwo = params['engagementName'];
        this.headerData.headTwoDesc=params['engagementNameDesc'];
        this.headerData1.headTwo = params['engagementName'];
        this.engagementName=params['engagementName'];
        this.headerData1.headTwoDesc=params['engagementNameDesc'];
        this.podId=params['podId'];
        this.creditorId=params['creditorId'];
        this.creditorName=params['creditorName'];
        this.headerData.isSubHeader = true;
        this.headerData.subHeaderButtonText = 'ADD';
        this.spinnerService.show();
        this.authorizationService.loadUserRolePrivileges(this.engagementId, this.creditorId, this.podId)
        .subscribe((response) => {
          if (response) {
            console.log(response);
            this.authorizationService.userRolePrivileges = response;
            this.authorizationService.setPrivileges(this.authorizationService.userRolePrivileges);
            this.accountmanagerOrDelegates=this.authorizationService.withdrawPODClaim;
          }
          this.spinnerService.hide();

        });
      });

      this.getBroadcastDocumentTypeLookup();
      this.getBroadcastNamePublishDateById();
      this.getBroadcastAdjudicatonDetail();
    }


    public getBroadcastAdjudicatonDetail(){
      this.spinnerService.show();
      let path = 'CreditorClaim/GetBroadcastAdjudicatonDetail';
      this.broadcastAdjudicationFilter.EngagementId = this.engagementId;
      this.broadcastAdjudicationFilter.FilterParamString = this.filterParamString;
      this.broadcastAdjudicationFilter.SortColumn = this.sortColumn;
      this.broadcastAdjudicationFilter.PageSize = this.pageSize;
      this.broadcastAdjudicationFilter.PageNumber = this.pageNumber;
      this.broadcastAdjudicationFilter.CreditorId = this.creditorId;

      this.dataService.postRequest(path,this.broadcastAdjudicationFilter)
        .subscribe((activeBroadcastApiResponse: any) => {
          this.spinnerService.hide();
          this.broadcastGridList = activeBroadcastApiResponse['broadcastProxyForm'];
          this.dataSource=this.broadcastGridList;
          this.broadcastGridList.forEach((x) => {
            if( x.submittedDateAndTime){
              x.submittedDateAndTime=""+moment.utc(x.submittedDateAndTime).format('DD-MMM-yyyy  hh:mm A');
            }
          });
          
          this.totalCountLength = activeBroadcastApiResponse['totalCount'];
        });
      
      
    }

    getBroadcastNamePublishDateById() {
      this.spinnerService.show();
      let path: string = 'broadcasts/broadcastnamepublishdatebyid?engagementId=' + this.engagementId +'&creditorId='+this.creditorId +'&isView='+this.isFromBroadcast;
      this.dataService.getRequest(path).subscribe((broadcastResponse: any[]) => {
        this.broadcastDetails = broadcastResponse;
        this.spinnerService.hide();
      });
    }

    async getBroadcastDocumentTypeLookup() {
      this.spinnerService.show();
      let path: string = 'broadcasts/broadcastdocumenttypelookup';
      this.dataService.getRequest(path).subscribe((broadcastdocumenttypelookupResponse: any[]) => {
        this.broadcastDocumentTypeLookup = broadcastdocumenttypelookupResponse;
        this.spinnerService.hide();
      });
    }
    onClickToRedirectToHomepage() {
      this.router.navigate(['creditorhome']);
    }
    onClicktoDelete(){

    }
    onClickToSelectAll(data:any){
      this.showRibbon= data;
    }

    
  redirectToProxyDetailPage(proxyFormId:any){
    this.spinnerService.show();
    let path: string = 'broadcasts/broadcastnamepublishdatebyid?engagementId=' + this.engagementId +'&creditorId='+this.creditorId +'&isView='+this.isFromBroadcast;
    this.dataService.getRequest(path).subscribe((broadcastResponse: any[]) => {
      this.broadcastDetails = broadcastResponse;
      this.spinnerService.hide();
      let data={
        creditorId:this.creditorId,
        particularsOfDebtId:this.podId,
        engagementId:this.engagementId,
        creditorName:this.dataSource.find(x=>x.proxyFormId==proxyFormId).creditorName,
        proxyFormId:proxyFormId,
        viewOrEdit:true,
        isEdit:false
      };
      const dialogRefDuplicate = this.dialog.open(AdjudicationProxyFormPopupComponent, {
      disableClose: true,
      width: '1500px',
      height:'800px',
      data: {
        primaryButVal: 'APPLY', 
        secondaryButVal: 'CANCEL',
        broadcastNamePublishDate:this.broadcastDetails,
        broadcastDocumentTypeLookup:this.broadcastDocumentTypeLookup,
        details:data
      },
    });
    dialogRefDuplicate.afterClosed().subscribe((res) => {
      if (res.data == 'APPLY') {
        this.spinnerService.show();
        this.getBroadcastAdjudicatonDetail();
        return;
      }
    });
    });
    
  }

  public emitPaginatorSplice(val) {
    this.pageSize = val.pageSize;
    this.pageNumber = val.selectedPage;
    this.getBroadcastAdjudicatonDetail();
  }

  redirectToAdjudicationSummmaryPopup()
  {
    this.spinnerService.show();
    let path: string = 'broadcasts/broadcastnamepublishdatebyid?engagementId=' + this.engagementId +'&creditorId='+this.creditorId +'&isView='+!this.isProxyFrom;
    this.dataService.getRequest(path).subscribe((broadcastResponse: any[]) => {
      this.broadcastDetails = broadcastResponse;
      this.spinnerService.hide();
      let data={
        creditorId:this.creditorId,
        particularsOfDebtId:this.podId,
        engagementId:this.engagementId,
        creditorName:this.creditorName
      };
      const dialogRefDuplicate = this.dialog.open(AdjudicationProxyFormPopupComponent, {
      disableClose: true,
      width: '1500px',
      height:'800px',
      data: {
        primaryButVal: 'APPLY', 
        secondaryButVal: 'CANCEL',
        broadcastNamePublishDate:this.broadcastDetails,
        broadcastDocumentTypeLookup:this.broadcastDocumentTypeLookup,
        details:data
      },
    });
    dialogRefDuplicate.afterClosed().subscribe((res) => {
      if (res.data == 'APPLY') {
        this.spinnerService.show();
        this.getBroadcastAdjudicatonDetail();
        return;
      }
    });
    });
    
    
  }    

  downloadFile(file:any){
    this.uploadService.downloadFile(file.orginalFilePath, file.submittedFileName)
  } 

  getRowClass(element:any):string{
    if(element.isSuperseded){
      return '';
    }
    else{
      return '#ccd0d3';
    }
  }

  onClickToSortHeader(data: { active: string; direction: string }){
    let asc: string = '-';
    let des: string = '+';

    if (data.direction == 'desc') { 
      this.sortColumn = des.concat(this.getSortColumnName(data.active));
    } else if (data.direction == 'asc') {
      this.sortColumn = asc.concat(this.getSortColumnName(data.active));
    }
    if(data.direction!=""){
    this.getBroadcastAdjudicatonDetail();
    }
  }

  private getSortColumnName(value: string): string {
    switch (value) {
      case 'broadCastName':
        return ProxyFormGridColumn.BroadcastName;
      case 'documentType':
        return ProxyFormGridColumn.DocumentType;
      case 'fileName':
        return ProxyFormGridColumn.SubmittedFileName;
      case 'submittedDateAndTime':
        return ProxyFormGridColumn.SubmittedDateAndTime;
      case 'submittedBy':
        return ProxyFormGridColumn.SubmittedBy;
    }
  }
  

}
